export default __webpack_public_path__ + "static/media/ei1.988afb80.jpg";